import styled, { css } from 'styled-components'
import { radiuses, media } from 'styles'

const shortStyles = css`
  .description,
  .theme-group-title {
    display: none;
  }
  input[type='color'] {
    width: 2rem;
    height: 2rem;
    padding: 0;
  }
`
const tinyStyles = css`
  .theme-groups {
    flex-direction: column;
  }
  .theme-section {
    padding: 1rem 0;
    max-width: 25rem;
    margin: auto;
  }
`

const StyledThemeEditor = styled.div`
  display: flex;
  box-shadow: 0 0 1rem ${p => p.colors.boxShadow};
  color: ${p => p.colors.textMain};
  background: ${p => p.colors.mainBackground};
  position: fixed;
  bottom: 0;
  opacity: 0.95;
  width: 95%;
  left: 2.5%;
  max-width: 120rem;
  border-radius: ${radiuses.large} ${radiuses.large} 0 0;

  .theme-section {
    flex: 1;
    padding: 1rem;
    &-title {
      color: ${p => p.colors.textSectionTitle};
      text-align: center;
      text-transform: uppercase;
      flex: 100%;
      font-size: 1.5rem;
      margin: 0;
    }
    &-normal,
    &-inverted {
      flex: 2;
      .theme-group {
        flex: 50%;
      }
    }
  }
  .theme-groups {
    display: flex;
  }
  .theme-group {
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    padding: 0.5rem;
    width: 100%;
    &-title {
      display: block;
      color: ${p => p.colors.textSecondary};
      padding-bottom: 0.5rem;
      text-align: center;
      text-transform: uppercase;
      font-size: 1.2em;
    }
  }
  .theme-item {
    border-radius: ${radiuses.medium};
    cursor: pointer;
    &:only-of-type {
      margin: auto 0;
    }
    display: flex;
    justify-content: space-between;
    padding: 0.5rem;
    .info {
      padding-right: 1rem;
      flex: 1;
    }
  }
  input {
    font-family: monospace;
    border: 1px solid ${p => p.colors.divider};
    background: ${p => p.colors.mainBackground};
    border-radius: ${radiuses.small};
    flex: none;
    &[type=text] {
      height: 2em;
      align-self: flex-end;
      text-align: center;
      color: ${p => p.colors.textMain};
    }
    &[type=color] {
      width: 3rem;
      height: 3rem;
      align-self: flex-start;
      cursor: pointer;
    }
  }
  #item-divider {
    border-bottom: 0.2rem solid ${p => p.colors.divider};
  }
  #item-boxShadow {
    margin-top: 1rem;
    box-shadow: 0 0 0.5rem ${p => p.colors.boxShadow};
  }
  .contrast {
    float: right;
    margin: 0.3rem 0;
  }
  .score {
    color: limegreen;
    background: black;
    box-shadow: 0 0 0.2rem 0.2rem black;
    margin-left: 0.5rem;

    &:empty::before {
      content: '❌';
      color: red;
    }
  }
  transition: transform 0.5s;
  &.closed {
    transform: translateY(100%);
    i {
      transform: rotate(-180deg);
    }
    .detailed, .keyboard, a {
      display: none;
    }
  }
  .actions {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translate(-50%, -100%);
    background: ${p => p.colors.mainBackground};
    box-shadow: 0 -0.3rem 0.5rem 0.2rem ${p => p.colors.boxShadow};
    border-radius: ${radiuses.large} ${radiuses.large} 0 0;
    i {
      transition: 0.5s;
      font-size: 2rem;
      padding: 0.5rem 1rem;
      cursor: pointer;
    }
    i, a {
      color: ${p => p.colors.textMain};
      &:hover {
        color: ${p => p.colors.highlight};
      }
    }
  }
  &.short .detailed, &.color .keyboard {
    font-weight: 400;
  }
  .dragHelper {
    position: absolute;
    top: 1rem;
    bottom: 1rem;
    left: 1rem;
    right: 1rem;
    border: 1rem dashed;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 3rem;
    color: ${p => p.colors.highlight};
    background: ${p => p.colors.mainBackground};
  }
  @media (min-width: 1280px) {
    left: 50%;
    margin-left: -60rem;
  }
  @media (min-width: 1026px) {
    &.long.text {
      .theme-item {
        position: relative;
      }
      .contrast {
        position: absolute;
        top: 0.5rem;
        right: 0.7rem;
      }
    }
  }
  &.short {
    ${shortStyles}
  }
  ${media.tablet`
    ${shortStyles}
    .detailed {
      display: none; /* descriptions are always hidden on tablets, so toggle should be as well */
    }
    input[type=color] {
      align-self: flex-end;
    }
    &.text {
      ${tinyStyles}
    }
  `}

  ${media.mobile`
    ${tinyStyles}
    .theme-section-title {
      display: none;
    }
  `}
  ${media.phone`
    display: block;
    width: 28rem;
    left: 50%;
    margin-left: -14rem;
    padding-top: 0.5rem;
    .theme-section, &.text .theme-section, .theme-group {
      padding: 0;
    }
  `}
`

export default StyledThemeEditor
